import React from "react";

const VibeCodingKreativitas: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p>
        Duel in Vibe Coding merupakan kompetisi pemrograman kreatif yang
        menantang peserta untuk menciptakan aplikasi atau permainan berbasis{" "}
        <a
          href="https://www.ibm.com/think/topics/artificial-intelligence"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          kecerdasan buatan (Artificial Intelligence)
        </a>
        . Di tengah pesatnya perkembangan teknologi digital, AI telah menjadi
        komponen penting dalam berbagai produk seperti aplikasi mobile, game
        interaktif, hingga sistem rekomendasi. Kompetisi ini mendorong generasi
        muda untuk menggabungkan logika pemrograman, kreativitas ide, serta
        pemanfaatan AI sebagai keterampilan strategis yang relevan dengan
        kebutuhan industri digital masa kini.
      </p>

      <p>
        Berbeda dari kompetisi pemrograman konvensional yang berfokus pada
        ketepatan algoritma, Duel in Vibe Coding mengusung pendekatan{" "}
        <a
          href="https://www.ibm.com/id-id/think/topics/vibe-coding?"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          vibe coding
        </a>
        . Pendekatan ini menekankan pada{" "}
        <a
          href="https://www.interaction-design.org/literature/topics/ux-design"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          pengalaman pengguna
        </a>, kreativitas
        desain, serta interaksi yang dinamis. Peserta diperkenalkan pada
        pendekatan modern di mana kebutuhan aplikasi diekspresikan melalui
        instruksi atau prompt yang kemudian diolah AI menjadi kode fungsional.
        Pendekatan ini memungkinkan proses pembuatan prototipe berlangsung
        lebih cepat, adaptif, dan relevan terhadap kebutuhan pengguna.
      </p>

      <p>
        Dalam kompetisi ini, AI berperan sebagai elemen utama yang membuat
        aplikasi atau game merespons perilaku pengguna secara real-time.
        Peserta mengeksplorasi berbagai penerapan AI, mulai dari logika
        berbasis data, karakter cerdas, hingga mekanisme permainan atau alur
        cerita yang adaptif. Melalui proses tersebut, peserta memahami bahwa
        keberhasilan produk digital tidak hanya ditentukan oleh fungsi teknis,
        tetapi juga oleh nilai, interaksi, dan pengalaman yang dirasakan pengguna.
      </p>

      <p>
        Pendekatan serupa dapat ditemukan pada{" "}
        <a
          href="https://vibecoding.id/hackathon"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          National Vibe Coding Competition 2025
        </a>
        yang diselenggarakan di Yogyakarta. Kompetisi ini menghadirkan berbagai
        tantangan seperti prompt-to-page development, AI debugging, hingga
        deployment aplikasi, serta didukung mini-class dan mentoring dari
        praktisi teknologi. Beragam proyek fungsional berhasil dikembangkan,
        menunjukkan bagaimana AI dapat mendukung pembuatan web app, layanan
        interaktif, dan solusi digital yang kontekstual.
      </p>

      <p>
        Dalam suasana kompetitif yang dinamis, Duel in Vibe Coding melatih
        peserta untuk berpikir cepat, inovatif, dan solutif. Peserta
        mengembangkan keterampilan abad ke-21 seperti creative problem
        solving, AI literacy, dan design thinking. Dengan dukungan ekosistem
        pembelajaran dari{" "}
        <a
          href="https://edukasi.accelist.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Accelist Edukasi Indonesia (AEDU)
        </a>
        , kompetisi ini menjadi wadah pembelajaran aplikatif yang
        mempersiapkan generasi muda menghadapi tantangan pengembangan produk
        digital berbasis AI di masa depan.
      </p>

      <p className="font-medium">👉 Cek untuk informasi Duel in Vibe Coding lebih lanjut.</p>
    </div>
  );
};

export default VibeCodingKreativitas;
